// extracted by css-extract-rspack-plugin
export default {"card":"OIVKc36___card","button":"pxlAJcK___button","image":"wZdgDN7___image","title":"r65FN0f___title"};